const env = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env ?? {};

const API_URL = (env.VITE_API_URL || 'https://verixa-core.onrender.com').trim();

const API_KEY = (env.VITE_API_KEY || '').trim();

type V1ChatResponse = {
  choices?: Array<{
    message?: {
      content?: string;
    };
  }>;
};

export async function sendMessage(message: string): Promise<string> {
  const requestId =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Request-ID': requestId,
  };

  if (API_KEY) {
    headers.Authorization = `Bearer ${API_KEY}`;
  }

  const response = await fetch(`${API_URL}/v1/chat/completions`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      model: 'default',
      messages: [{ role: 'user', content: message }],
    }),
  });

  if (!response.ok) {
    throw new Error(`Falha na comunicação com a IA (status ${response.status})`);
  }

  const data = (await response.json()) as V1ChatResponse;
  const content = data?.choices?.[0]?.message?.content;
  return typeof content === 'string' && content.trim() ? content : 'Sem resposta da IA';
}
